var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListItem',{staticClass:"l-inline l-spread l-center"},[_c('div',[_vm._v(_vm._s(_vm.$t(_vm.name)))]),_c('ToggleButton',{attrs:{"value":_vm.output},on:{"change":_vm.doSwitch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }